"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Button = _interopRequireDefault(require("../../Button"));
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ResultBox(_ref) {
  var title = _ref.title,
    children = _ref.children,
    onPress = _ref.onPress;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Title, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Message, {
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ButtonWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
        title: "Ok",
        width: 156,
        onPress: onPress
      })
    })]
  });
}
ResultBox.propTypes = {
  title: _propTypes.string.isRequired,
  children: _propTypes.string.isRequired,
  onPress: _propTypes.func.isRequired
};
var _default = exports["default"] = ResultBox;